import { render, staticRenderFns } from "./right.vue?vue&type=template&id=6d3a16cc&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=6d3a16cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a16cc",
  null
  
)

export default component.exports